/**
 * KYRDROS — in-memory session store.
 * KS-PF1: Session is server-authoritative (HttpOnly cookie + server-side DB).
 * This module holds the client-side shadow of the session for React rendering.
 * CSRF token is stored here and injected into all state-changing requests by api.js.
 */

let _user = null;   // { user_id, email, display_name, organization_id, role, ... }
let _csrf = null;   // CSRF token from last login or /api/auth/me hydration

export const session = {
  /** Store the user object and CSRF token after a successful login or /me call. */
  hydrate: (userData) => {
    _user = userData;
    _csrf = userData?.csrf_token ?? null;
  },

  /** Clear all session state (logout / 401). */
  clearAll: () => {
    _user = null;
    _csrf = null;
  },

  /** Returns true if a user is currently hydrated in memory. */
  hasAccess: () => _user !== null,

  /** Returns the current user object, or null. */
  getUser: () => _user,

  /** Returns the current CSRF token, or null. */
  getCsrfToken: () => _csrf,
};

